import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../src/assets/scss/AddInviteForm.module.scss';
import { useCreateUserTypeMutation, useGetRoleQuery } from '../../slices/admin/admin';
import { toast } from 'react-toastify';

const AddUserType = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        usertype: '',
        description: '',
        isActive: '',
        comments: '',
        roleId: '',
    });

    const [errors, setErrors] = useState({});

    const { data: userRoleData, isLoading: userTypeLoading, isError } = useGetRoleQuery({
        offset: 1,
        limit: 100,
        isActive: true,
        search: '',
    });
    const [createUserType, { isLoading: isCreating }] = useCreateUserTypeMutation();


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCancel = () => {
        setFormData({
            usertype: '',
            description: '',
            isActive: '',
            comments: '',
            roleId: '',
        });
        navigate(-1);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.usertype.trim()) newErrors.usertype = 'User Type is required';
        if (!formData.description.trim()) newErrors.description = 'Description is required';
        if (formData.isActive !== 'true' && formData.isActive !== 'false') newErrors.isActive = 'Select Active status';
        if (!formData.comments.trim()) newErrors.comments = 'Comments required';
        if (!formData.roleId.trim()) newErrors.roleId = 'Role is required';
        return newErrors;
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();

        if (Object.keys(validationErrors).length === 0) {
            const payload = {
                ...formData,
                isActive: formData.isActive === 'true',
            };

            try {
                const response = await createUserType(payload).unwrap();
                toast.success('User Type created successfully!');

                // Reset form after successful submission
                setFormData({
                    usertype: '',
                    description: '',
                    isActive: '',
                    comments: '',
                    roleId: '',
                });
                setErrors({});
                navigate(-1); // Or redirect to '/dashboard/user-type'
            } catch (error) {
                toast.error(error?.data?.message || 'Failed to create user type');
            }
        } else {
            setErrors(validationErrors);
        }
    };


    return (
        <div className={styles.addInviteContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>Add User Type</h2>
                <span className={styles.closeIcon} onClick={handleCancel}>✕</span>
            </div>

            <form className={styles.form} onSubmit={handleSubmit}>
                <div className={styles.row}>
                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>User Type</label>
                        <input
                            type="text"
                            name="usertype"
                            value={formData.usertype}
                            onChange={handleChange}
                            placeholder="User Type"
                            className={styles.input}
                        />
                        {errors.usertype && <span className={styles.error}>{errors.usertype}</span>}
                    </div>

                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder="Description"
                            className={styles.input}
                        />
                        {errors.description && <span className={styles.error}>{errors.description}</span>}
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Active Status</label>
                        <select
                            name="isActive"
                            value={formData.isActive}
                            onChange={handleChange}
                            className={styles.inputs}
                        >
                            <option value="">Select Status</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>
                        {errors.isActive && <span className={styles.error}>{errors.isActive}</span>}
                    </div>

                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Comments</label>
                        <input
                            type="text"
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                            placeholder="Please don't delete"
                            className={styles.input}
                        />
                        {errors.comments && <span className={styles.error}>{errors.comments}</span>}
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.inputGroup}>
                        <label className={styles.inputLabel}>Role</label>
                        <select
                            name="roleId"
                            value={formData.roleId}
                            onChange={handleChange}
                            className={styles.inputs}
                            disabled={userTypeLoading}
                        >
                            <option value="">Select Role</option>
                            {userRoleData?.result?.map((role) => (
                                <option key={role._id} value={role._id}>
                                    {role.roleName}
                                </option>
                            ))}
                        </select>
                        {errors.roleId && <span className={styles.error}>{errors.roleId}</span>}
                        {isError && <span className={styles.error}>Failed to load roles</span>}
                    </div>
                    <div className={styles.inputGroup}></div>
                </div>

                <div className={styles.buttonGroup}>
                    <button type="button" className={styles.cancelButton} onClick={handleCancel}>Cancel</button>
                    <button
                        type="submit"
                        className={styles.sendButton}
                        disabled={isCreating}
                    >
                        {isCreating ? 'Saving...' : 'Save'}
                    </button>

                </div>
            </form>
        </div>
    );
};

export default AddUserType;


